



















































































import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Review extends Vue {
  calendlyDemoLink = window.calendlyDemoLink;
}
